import { useScreenOrientation } from "hooks/useScreenOrientation";

export const useRotationWarningOverlay = () => {
  const { isMobileLandscape } = useScreenOrientation();

  return { isMobileLandscape };
};
